import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { FaCheckCircle, FaClipboardCheck, FaSearchPlus, FaShieldAlt } from 'react-icons/fa';
import { fadeInUp, staggerContainer, standardViewport } from '../../utils/animation';
import './ProcessQuality.scss';

const ProcessQuality = () => {
  const { t } = useTranslation('process');
  const items = t('quality.items', { returnObjects: true });
  const icons = [<FaClipboardCheck />, <FaSearchPlus />, <FaCheckCircle />, <FaShieldAlt />];
  const itemKeys = ['certifications', 'testing', 'traceability', 'freshness'];
  
  // Folosim animații centralizate pentru consistență

  return (
    <section className="process-quality">
      <div className="container">
        <motion.h2
          className="process-quality__title"
          initial="hidden"
          whileInView="visible"
          viewport={standardViewport}
          variants={fadeInUp}
        >
          {t('quality.title')}
        </motion.h2>
        <motion.p
          className="process-quality__intro"
          initial="hidden"
          whileInView="visible"
          viewport={standardViewport}
          variants={fadeInUp}
        >
          {t('quality.intro')}
        </motion.p>
        
        <motion.div
          className="process-quality__grid"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={standardViewport}
        >
          {itemKeys.map((key, index) => (
            <motion.div key={key} className="process-quality__item" variants={fadeInUp}>
              <div className="process-quality__icon">
                {icons[index]}
              </div>
              <h3 className="process-quality__item-title">{items[key].title}</h3>
              <p className="process-quality__description">
                {items[key].description}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default ProcessQuality;
